import React from "react";
import helper from "../../../helper/helper";
import typo from '../../../constants/dictionaries'

const columns = ({handleShowDetail} = {}) =>
  [
    {
      title: "#",
      dataIndex: "stt",
      width: "45px",
      align: 'center',
    },
    {
      title: "Số quyết định",
      dataIndex: "soQD",
      render: (value, row) => <a onClick={() => handleShowDetail(row)}>{value}</a>
    },
    {
      title: typo.cscore_license_signed_person,
      dataIndex: "nguoiKy",
      width: "150px",
    },
    {
      title: typo.cscore_license_available_date,
      dataIndex: "ngayBD_HieuLuc",
      width: "120px",
      render: (value, row) => (helper.formatTableDate(row.ngayBD_HieuLuc)),
    },
  ].map(col => ({ ...col}));

export default columns;
